<div class="container-fluid py-2 d-flex flex-column">
  <div class="row h-100">
    <div class="col-4 h-100 d-flex flex-column">
      <ul
        class="list-group list-group-hover list-group-striped overflow-y-scroll relative" style="flex-grow: 1">
        <li (click)="setSelectedItem(item)" class="list-group-item mat-caption"
          [class.item-selected]="selectedItem && selectedItem.customerQualityClauseId === item.customerQualityClauseId"
          *ngFor="let item of customer.qualityClauses; index as i">
          <span [innerHTML]="item.name | highlight: filter"></span>
        </li>
      </ul>
      <button *ngIf="editing" [disabled]="!editing || isCreating" mat-flat-button color="primary" [class.bg-success]="editing && !isCreating"
        class="mt-2 new-item-button" (click)="createNewItem()">
        New Item
      </button>
    </div>
    <div class="col-8 h-100">
      <mat-card class="h-100 mat-elevation-z0 border border-secondary" [class.p-0]="!selectedItem">
        <div *ngIf="!selectedItem"
          class="bg-light p-3 w-100 h-100 d-flex align-items-center justify-content-center text-muted font-italic">
          Choose or
          create a QC clause from the left
          panel.</div>
        <ng-container *ngIf="!!selectedItem">
          <mat-card-header>
            <mat-card-title>
              {{ isCreating ? 'Creating' : 'Editing' }}
              Quality Clause</mat-card-title>
            <mat-card-subtitle>
              <span>{{selectedItem.name ?? '&nbsp;'}}</span>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <form #itemForm="ngForm">
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Clause Name</mat-label>
                    <input matInput autocomplete="off" type="text" [(ngModel)]="selectedItem.name" name="name"
                      required [readonly]="!editing">
                    <mat-error *ngIf="itemForm.controls['name']?.errors?.required">
                      Clause name is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Clause Text</mat-label>
                <textarea style="min-height: 4em;" matInput rows="10" autocomplete="off" [(ngModel)]="selectedItem.text"
                    [readonly]="!editing"
                  name="text"></textarea>
              </mat-form-field>
            </form>
          </mat-card-content>
          <mat-card-actions align="end">
            <button type="button" mat-flat-button color="warn" class="mr-2" *ngIf="editing && !isCreating"
              (click)="deleteSelected()">
              Delete
            </button>
            <button type="submit" mat-flat-button color="primary" class="mr-5"
              [disabled]="itemForm.invalid || itemForm.pristine" (click)="saveSelected()">
              Save
            </button>
          </mat-card-actions>
        </ng-container>
      </mat-card>
    </div>
  </div>
</div>
